import Search from '../src/containers/Search';

export default Search;